import { useActionInput } from '../context';
import { ActionModule } from '../types';

export const useIsEnabled = <T extends ActionModule>(tag: T) => {
	const { modules } = useActionInput();

	return modules.includes(tag);
};
